module.exports = __webpack_public_path__ + "static/media/bouee_de_sauvetage.02b8e56d.png";